/** Maximum number of venues that can be compared simultaneously. */
export const MAX_COMPARE_SLOTS = 4;

/** Width in pixels of the original-quote bar in the savings chart (from Figma); the current-price bar scales against it. */
export const SAVINGS_BAR_MAX_PX = 192;

/** Agenda rows shown while comparison data is loading. */
export const SKELETON_MEETING_DAY_COUNT = 3;

/** Shadow style applied to the sticky left label column when horizontally scrolled. */
export const STICKY_LABEL_SHADOW: React.CSSProperties = {
  boxShadow: "4px 0 8px -2px rgba(0,0,0,0.1)",
  clipPath: "inset(0 -12px 0 0)",
};
